import { render, staticRenderFns } from "./ImageInspoPost.vue?vue&type=template&id=770fa352&scoped=true&"
import script from "./ImageInspoPost.vue?vue&type=script&lang=js&"
export * from "./ImageInspoPost.vue?vue&type=script&lang=js&"
import style0 from "./ImageInspoPost.vue?vue&type=style&index=0&id=770fa352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770fa352",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarouselItem,VImg})
